document.addEventListener('DOMContentLoaded', function () {
    toggleHeaderSearch()
    toggleMobileMenus()
    toggleMobileSearch()
    storeSearches()
    apendStoredSearches()
    toggleSearchFilters()
    headerSticky()
    trinityAudio()
    handleHistoricoSelects()
}, false )

const handleHistoricoSelects = () => {
    const YEAR_SELECT   = document.getElementById('publish_year')
    const NUMBER_SELECT = document.getElementById('num_revista')

    if( YEAR_SELECT != null && NUMBER_SELECT != null ) {

        const filterOptions = (year) => {
            Array.from(NUMBER_SELECT.options).forEach((option) => {
                if ( option.dataset.year === year || year === '' ) {
                    option.style.display = 'block'
                } else if ( option.value != '' ) {
                    option.style.display = 'none'
                }
            });
        };

        YEAR_SELECT.addEventListener('change', (e) => {
            filterOptions(e.target.value)
        });

        const urlParams = new URLSearchParams(window.location.search);
        const publishYear = urlParams.get('publish_year')
        if ( publishYear ) {
            YEAR_SELECT.value = publishYear
            filterOptions(publishYear);
        }
    }
}

const trinityAudio = () => {
    const PLAYBUTTON    = document.getElementById('play-button');
    const AUDIODIV      = document.getElementById('trinity-audio-div');

    if (PLAYBUTTON && AUDIODIV) {
        PLAYBUTTON.addEventListener('click', function () {
            AUDIODIV.classList.toggle('hidden-trinity-audio');
        });
    }
}

const headerSticky = () => {

    const SITE_HEADER       = document.querySelector( '.site-header' )
    const STICKY_CLASS      = 'sticky'

    window.addEventListener('scroll', () => {
        const SCROLL_POSITION   = window.scrollY

        if (SCROLL_POSITION > 100) {
            SITE_HEADER.classList.add(STICKY_CLASS);
        } else {
            SITE_HEADER.classList.remove(STICKY_CLASS);
        }
    })
}

const toggleHeaderSearch = () => {

    const PRIMARY_NAV   = document.getElementById( 'primary-nav' )
    const SEARCH_BTN    = PRIMARY_NAV.querySelector('.search-btn')
    const SEARCH_FORM   = PRIMARY_NAV.querySelector('.search-container')

    SEARCH_BTN.addEventListener('click', () => {
        SEARCH_FORM.classList.toggle('open')
    })

    document.addEventListener( 'click', ( e ) => {
        const eventTarget = e.target;
        const parent = eventTarget.closest( '.search-container' );
        if( eventTarget != SEARCH_BTN && SEARCH_FORM.classList.contains( 'open' ) && null == parent ) {
            SEARCH_FORM.classList.remove( 'open' )
        }
    })

}

const toggleMobileSearch = () => {

    const MOBILE_SEARCH_BTN = document.querySelector( '#mobile-navigation #search-icon' )
    let mobileSearchPanel   = document.getElementById( 'search-panel' )
    const CLOSE_BTN         = mobileSearchPanel.querySelector( '.icon-arrow' )
    MOBILE_SEARCH_BTN. addEventListener( 'click', () => {
        mobileSearchPanel.classList.add( 'open' )
    })

    CLOSE_BTN.addEventListener( 'click', () => {
        mobileSearchPanel.classList.remove( 'open' )
    })
}

const toggleMobileMenus = () => {

    const HAMBURGUER    = document.getElementById( 'hamburguer-icon' )
    const MOBILE_MENU   = document.getElementById( 'mobile-menu' )
    const PARENT_ITEMS  = document.querySelectorAll( '#primary-panel .has-child' )
    const CLOSE_BTNS    = document.querySelectorAll( '.panel-options .close-btn')
    const BACK_BTNS     = document.querySelectorAll( '.panel-options .back')

    HAMBURGUER.addEventListener( 'click', () => {
        MOBILE_MENU.classList.toggle( 'open' )
        document.body.classList.add( 'mobile-open' )
    })

    CLOSE_BTNS.forEach( ( btn ) => {
        btn.addEventListener( 'click', () => {
            MOBILE_MENU.classList.remove( 'open' )
            let panel = btn.closest( '.child-panel' )
            panel && panel.classList.remove( 'open' )
            document.body.classList.remove( 'mobile-open' )
        })
    })

    BACK_BTNS.forEach( ( btn ) => {
        btn.addEventListener( 'click', () => {
            btn.closest( '.child-panel' ).classList.remove( 'open' )
        })
    })

    PARENT_ITEMS.forEach( ( item ) => {
        item.addEventListener( 'click', ( e ) => {
            e.preventDefault
            let targetPanel = document.getElementById( 'panel-' + e.target.dataset.panel )
            targetPanel.classList.toggle( 'open' )
        })
    })
}

const storeSearches = () => {

    const SEARCH_FORMS = document.querySelectorAll('.search-form');

    SEARCH_FORMS.forEach( ( form ) => {
        form.addEventListener( 'submit', ( e ) => {

            let handledSearch = new FormData( form ).get( 's' )
            let storedSearches = localStorage.getItem( 'storedSearches' )
            let dataObj = new Object()

            dataObj.search = handledSearch
            handledSearch = JSON.stringify( dataObj )

            if( null != storedSearches ) {
                let data = JSON.parse( storedSearches )
                if (data.length > 9) {
                    data.shift();
                }
                data.push( handledSearch )
                localStorage.setItem( 'storedSearches', JSON.stringify( data ))
            } else {
                localStorage.setItem( 'storedSearches', JSON.stringify( [ handledSearch ] ))
            }
        })
    })
}

const apendStoredSearches = () => {
    let searchesContainer = document.querySelector('#search-panel #stored-searches')
    let storedSearches = localStorage.getItem( 'storedSearches' )
    if( null != storedSearches ) {
        let dataSearches = JSON.parse( storedSearches )
        dataSearches.reverse()
        searchesContainer.removeChild( searchesContainer.querySelector( '.no-results' ) )
        dataSearches.forEach( ( item ) => {
            let itemValue = JSON.parse(item).search
            let searchItem = document.createElement('a')
            searchItem.classList.add('search-item')
            searchItem.href = window.location.protocol +
                '//' + window.location.host +
                '?s=' + encodeURIComponent( itemValue )
            searchItem.textContent = itemValue
            searchesContainer.appendChild(searchItem)
        })
    }
}

const toggleSearchFilters = () => {

    const SEARCH_SIDEBAR = document.getElementById( 'search-sidebar' )
    if( SEARCH_SIDEBAR != null ) {
        let toggleFilters = SEARCH_SIDEBAR.querySelector('.toggle-filters')
        let searchFilters = SEARCH_SIDEBAR.querySelector('#search-filters')
        toggleFilters.addEventListener( 'click', (e) => {
            e.preventDefault()
            toggleFilters.classList.toggle( 'open' )
            searchFilters.classList.toggle( 'open' )
        })
    }
}
